import { render, staticRenderFns } from "./ui-label-switch.vue?vue&type=template&id=7d82a689"
import script from "./ui-label-switch.vue?vue&type=script&lang=js"
export * from "./ui-label-switch.vue?vue&type=script&lang=js"
import style0 from "./ui-label-switch.vue?vue&type=style&index=0&id=7d82a689&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports